$('.deletedoc-btn').on('click', function () {
    var deleteabscensemodal = $('#deleteabscensemodal');
    var id = $(this).data('id');
    var studentname = $(this).data('studentname');
    var date = $(this).data('date');

    $(deleteabscensemodal).find('#student-name').text(studentname);
    $(deleteabscensemodal).find('input[type="hidden"][name="id"]').val(id);
    $(deleteabscensemodal).find('#absence-dates').text(date);
    $(deleteabscensemodal).modal('show');
});

$('#absenceQuickSearchForm').validate({
    rules: {
        absenceSearchStudentID: {
            required: true,
        },
    },
    messages: {
        absenceSearchStudentID: {
            required: 'Please select a student',
        },
    },
});
